import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePlan } from "@/hooks/usePlan";
import { useNavigate } from "react-router-dom";

/** Shown when plan_status is 'past_due' */
export function PaymentFailureBanner() {
  const { isPastDue } = usePlan();
  const navigate = useNavigate();

  if (!isPastDue) return null;

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between px-4 py-2.5 border-b" style={{ background: "#FEF3C7", borderColor: "#D97706" }}>
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4" style={{ color: "#D97706" }} />
        <span className="text-sm font-body font-medium" style={{ color: "#78350F" }}>
          Your last payment failed. Please update your payment details to keep Professional access.
        </span>
      </div>
      <Button size="sm" onClick={() => navigate("/settings")} className="font-body">
        Update payment details
      </Button>
    </div>
  );
}
